import { isBlank } from "@/lib/prelude/presence";
import { SettingsState } from "@/modules/settings/SettingsState";
import { action, makeObservable, observable } from "mobx";

/**
 * Remembers which BYOK API key fields were non-empty when the settings dialog last
 * transitioned to open, so clearing a field in the UI does not hide it until the next open.
 */
export class SettingsByokFieldVisibilitySession {
  private dialogWasOpen = false;

  deepgramKeyFieldSlotThisDialogOpen = false;
  openaiKeyFieldSlotThisDialogOpen = false;
  deeplKeyFieldSlotThisDialogOpen = false;
  googleTranslateKeyFieldSlotThisDialogOpen = false;

  constructor() {
    makeObservable(this, {
      deepgramKeyFieldSlotThisDialogOpen: observable,
      openaiKeyFieldSlotThisDialogOpen: observable,
      deeplKeyFieldSlotThisDialogOpen: observable,
      googleTranslateKeyFieldSlotThisDialogOpen: observable,
      syncDialogOpenAndMaybeCapture: action,
    });
  }

  syncDialogOpenAndMaybeCapture(
    settingsDialogOpen: boolean,
    settingsState: SettingsState
  ) {
    if (settingsDialogOpen === this.dialogWasOpen) {
      return;
    }
    if (settingsDialogOpen) {
      this.deepgramKeyFieldSlotThisDialogOpen = !isBlank(
        settingsState.deepgramApiKeyState.value
      );
      this.openaiKeyFieldSlotThisDialogOpen = !isBlank(
        settingsState.openaiApiKey.value
      );
      this.deeplKeyFieldSlotThisDialogOpen = !isBlank(
        settingsState.deeplApiKeyState.value
      );
      this.googleTranslateKeyFieldSlotThisDialogOpen = !isBlank(
        settingsState.googleTranslateApiKeyState.value
      );
    }
    this.dialogWasOpen = settingsDialogOpen;
  }
}
